import { render, staticRenderFns } from "./MyTasks.vue?vue&type=template&id=215124fb&scoped=true"
import script from "./MyTasks.vue?vue&type=script&lang=js"
export * from "./MyTasks.vue?vue&type=script&lang=js"
import style0 from "./MyTasks.vue?vue&type=style&index=0&id=215124fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215124fb",
  null
  
)

export default component.exports